import { render, staticRenderFns } from "./mock-wine-release-landing.vue?vue&type=template&id=06e113ac&scoped=true&"
import script from "./mock-wine-release-landing.vue?vue&type=script&lang=js&"
export * from "./mock-wine-release-landing.vue?vue&type=script&lang=js&"
import style0 from "./mock-wine-release-landing.vue?vue&type=style&index=0&id=06e113ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e113ac",
  null
  
)

export default component.exports